import type {SingleTaskBatchScanResult} from "../scan-model/GroupedTaskBatchesScanResult.tsx";
import {useMemo} from "react";
import {Timestamp} from "../../../components/time-display/Timestamp.tsx";
import {Duration} from "../../../components/time-display/Duration.tsx";
import {implementationName} from "../../../metl-models/util/ComponentMap.ts";

function LongestRunning({comps}: {comps: Record<number, number>}) {
    const [component, longest] = useMemo(() => {
        let longest = 0
        let component = -1
        Object.entries(comps).forEach(([comp, time]) => {
            if (time > longest) {
                longest = time
                component = parseInt(comp)
            }
        })
        return [component, longest]
    }, [comps])
    return <span>{implementationName(component)} - <Duration duration={longest} /></span>
}

interface Props {
    tasks: SingleTaskBatchScanResult[]
}
export function IndividualTaskAnalysisDisplay({tasks}: Props) {
    const sorted = useMemo(() => {
        if(tasks.length > 1000) return []
        return tasks.sort((a, b) => {
            return a.overallStartTime - b.overallStartTime;
        })
    }, [tasks])
    if(tasks.length > 1000) return <div>
        <h3>Individual task analysis</h3>
        <p>Too many tasks to display. {tasks.length} tasks analyzed</p>
    </div>
    return <div>
        <h3>Individual task analysis</h3>
        <table>
            <thead>
                <tr>
                    <th>Version</th>
                    <th>Start job</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Duration</th>
                    <th>Longest running component</th>
                    <th>Utilisation</th>
                </tr>
            </thead>
            <tbody>
                {sorted.map((task) => <tr key={task.batchInfo.id}>
                    <td>{task.batchInfo.groupName}/{task.batchInfo.projectName}/{task.batchInfo.versionName}</td>
                    <td>{task.batchInfo.jobName}</td>
                    <td><Timestamp time={task.overallStartTime} /></td>
                    <td><Timestamp time={task.overallEndTime} /></td>
                    <td><Duration duration={task.totalDuration} /></td>
                    <td><LongestRunning comps={task.componentImplementationTimes} /></td>
                    <td>Max: {task.overlaps.highestOverlap} - Mean: {task.overlaps.meanOverallOverlap.toFixed(3)}</td>
                </tr>)}
            </tbody>
        </table>
    </div>
}